import { LinearProgress } from '@mui/material';

function MUILinerProgress() {
  return <LinearProgress sx={{ width: '100%', top: 0, position: 'absolute' }} />;
}

export default MUILinerProgress;
